// tslint:disable: max-line-length

const service = `<article>
<p>
    <span style="font-size:12pt;">版本更新日期：【2022】年【04】月【29】日
</p>
<p>
    <span style="font-size:12pt;">版本生效日期：【2022】年【04】月【29】日
</p>
<p>
    欢迎您使用小奥AI编程。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;为保障您在使用小奥AI编程各项服务时的利益，请您仔细阅读以下条款，当您登录成功，即意味着您完全接受本协议项下的全部条款。特别是免除或者限制责任的条款、争议解决和法律适用条款以及本协议中其他与您权益（可能）存在重大关系的条款，我们已采用加粗和/或加下划线的方式进行特别提示，您应重点阅读。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;【监护人告知】未成年人用户（特别是不满14周岁）请在父母或者其他监护人的陪同下阅读本协议，并在提交个人信息之前寻求父母或其他监护人的同意和指导。
</p>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            一、您的权利与义务
        </p>
    </li>
</ol>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            1.1 您在申请本服务过程中，需要填写一些必要的信息，请保持这些信息的真实、准确、合法、有效并注意及时更新，以便小奥AI编程向您提供及时有效的帮助，或更好地为您提供服务。根据相关法律法规和政策，请您填写真实的身份信息。若您填写的信息不完整或不准确，则可能无法使用本服务或在使用过程中受到限制。
        </p>
    </li>
    <li>
        <p>
            1.2 您同意遵守本协议，您了解本协议的内容可能会不时变更。如您不同意小奥AI编程对本协议所做的修改，您有权停止使用本系统，并要求小奥AI编程注销您的账户，此种情况，您需要自行备份业务数据。如您继续使用本系统，则视为您接受小奥AI编程对本协议做的修改。
        </p>
    </li>
    <li>
        <p>
            1.3 您在使用本服务前需要注册一个帐号，您对自己使用过程中产生的账号、数据等的完整性和保密性负责。因您维护不当或保密不当致使上述账号、数据等丢失或泄漏所引起的一切损失和后果均由您自行承担。
        </p>
    </li>
    <li>
        <p>
            1.4 您不得利用本平台制作、复制、发布，传播法律、法规和政策禁止的内容，不得利用本平台制作、复制、发布、传播干扰本平台正常运营，以及侵犯其他用户或第三方合法权益的内容。
        </p>
    </li>
    <li>
        <p>
            1.5 因您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向小奥AI编程、合作公司或关联公司主张任何索赔或要求，包括合理的律师费，若小奥AI编程与合作公司、关联公司赔偿后，有权向您追偿，您有义务赔偿小奥AI编程与合作公司、关联公司的所有损失。
        </p>
    </li>
    <li>
        <p>
            1.6 小奥AI编程有权依合理判断对违反有关法律法规或本协议规定行为进行处罚，对违法违规的任何人士采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此产生的一切法律责任。
        </p>
    </li>
</ol>
<p style="margin-left: 28px; ">
    <br/>
</p>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            二、小奥AI编程的权利和义务
        </p>
    </li>
</ol>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;2.1 许可使用权。小奥AI编程对您创作发表在本平台、学习沟通群的供学习交流的作品、学习过程分享的视频和图文，享有独家的出版、发行和复制的权利。您授予小奥AI编程及其关联公司独家的、全球通用的、永久的、免费的作品许可使用权利&nbsp;(并有权在多个层面对该权利进行再授权)，使小奥AI编程及其关联公司有权(全部或部份地)&nbsp;使用、复制、修订、改写、发布、翻译、分发、执行和展示用户的全部资料数据（包括但不限于注册资料、交易行为数据及全部展示于网站的各类信息）或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内；且小奥AI编程有权将上述作品、图文等多形式内容及其许可使用权用于正常的商业用途。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;2.2 如果小奥AI编程发现或收到他人举报或投诉您违反本协议约定的，小奥AI编程有权不经通知随时对相关内容进行删除，小奥AI编程有权不经通知随时删除含有任何危害国家安全、淫秽色情、虚假、侮辱、诽谤、恐吓、骚扰、侵犯他人版权或人身权或其他合法权益等违法或有违社会公序良俗的内容。若情节严重，小奥AI编程有权向有关部门举报检举。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;2.3 小奥AI编程应按照协议约定提供产品服务，保证服务在服务期内可正常运行。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;2.4 小奥AI编程保留为维护系统升级而短暂停止服务的权利，在暂停服务前后，小奥AI编程将通过网站予以公告
</p>
<p>
    <br/>
</p>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            三、保密责任
        </p>
    </li>
</ol>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;3.1&nbsp;保密资料指由一方向另一方披露所有技术及非技术信息，包括但不限于产品资料、产品计划、价格、财务及营销规划、业务战略、客户信息、客户数据、研发、软件硬件、API应用数据接口、技术说明、设计、特殊公式、特殊算法等。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;3.2&nbsp;本协议任何一方同意对获悉的对方之上述保密资料予以保密，并严格限制接触上述保密信息的员工遵守本条之保密义务。除国家机关依法强制要求或上述保密资料已经进入公有领域外，接受保密资料的一方不得对外披露。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;3.3本协议双方完全认可各自用户信息和业务数据等是各自的重要资产及重点保密信息。本协议双方同意保护上述保密信息等不被披露。一旦发现有上述保密信息泄露事件，双方应合作采取一切合理措施避免或者减轻损害后果的产生。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;3.4&nbsp;本条款不因本协议的终止而失效。
</p>
<p>
    <br/>
</p>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            四、服务期限与终止
        </p>
    </li>
</ol>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;4.1&nbsp;如果你与小奥AI编程已经签署销售协议，服务期限由该协议约定；如果没有，自您创建成功小奥AI编程服务之日起（而非您获取的管理员登录号和密码之日起）计算，并以您所缴纳的服务费款项数额为依据确认服务期限。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;4.2发生下列情形，协议提前终止：
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）双方协商一致提前终止的。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）您严重违反本协议，包括但不限于您未按照协议约定履行付款义务；您严重违反法律规定、违反本协议约定等。小奥AI编程有权提前终止服务，并不退还您已经支付费用。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）根据法律法规、监管政策等的规定或有权机关的要求。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;4.3&nbsp;如发生下列任何一种情形，小奥AI编程有权单方面中断或终止本协议，取消用户继续使用小奥AI编程在线产品及服务的资格：
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）用户盗用他人的个人信息或手机；
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）注册用户提供虚假信息；
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）未按时支付足额费用；
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）以非法手段（包括且不限于黑客攻击等）使用本系统；
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（5）按照法律规定或主管部门的要求；
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（6）出于安全的原因或其他必要的情形；
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（7）其他违反本协议的行为及违法行为；
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（8）用户意外身故。
</p>
<p>
    <br/>
</p>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            五、数据、内容和知识产权
        </p>
    </li>
</ol>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;小奥AI编程中的应用程序、源代码、LOGO、界面设计、应用程序编程接口（API）所关联的所有知识产权均归属小奥AI编程所有。除另有特别声明外，小奥AI编程提供本服务时所依托软件的著作权、专利权及其他知识产权均归小奥AI编程所有。上述及其他任何本服务包含的内容的知识产权均受到法律保护，未经小奥AI编程、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
</p>
<p>
    <br/>
</p>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            <span style="font-weight: bold; text-decoration-line: underline; color: rgb(47, 6, 0); background-color: rgb(255, 255, 255); font-size: 13pt;">六、免责声明</span>
        </p>
    </li>
</ol>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;<span style="font-weight: bold; text-decoration-line: underline; color: rgb(47, 6, 0); background-color: rgb(255, 255, 255); font-size: 13pt;">在法律允许的范围内，小奥AI编程对以下情形导致的服务中断、受阻或损失不承担责任：
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.不可抗力：不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会的事件如战争、动乱、政府行为等。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.用户或小奥AI编程的电脑软件、系统、硬件和通信线路出现故障。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.用户操作不当。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.用户通过非小奥AI编程授权的方式使用本服务。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.其他小奥AI编程无法控制或合理预见的情形。
</p>
<p style="text-indent: 34.73px;">
    <span style="font-weight:bold;">不论是否可以预见，不论是源于何种形式的行为，我们不对由任何原因造成的特别的、间接的、惩罚性的、突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失、经营中断、资料灭失）承担责任。</span>
</p>
<p>
    <br/>
</p>
<ol class=" list-paddingleft-2">
    <li>
        <p>
            七、特别声明
        </p>
    </li>
</ol>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;7.1&nbsp;小奥AI编程郑重提示：为享有高效优质的服务，请您务必仔细阅读并确保完全理解本协议。您完全理解并充分认可，任何人士和机构提供的文件（包括但不限于本协议）中有关服务描述与该协议矛盾的，以该协议为准。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;7.2&nbsp;本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;7.3&nbsp;本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;7.4&nbsp;本协议的订立、执行和解释及争议的解决均应适用中国法律。如发生小奥AI编程服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对您产生法律效力和影响。
</p>
<p>
    &nbsp;&nbsp;&nbsp;&nbsp;7.5 因本协议引起的或与本协议有关的任何争议，双方可友好协商解决；协商不成，可将争议提交小奥AI编程所在地有管辖权的人民法院管辖。
</p>
<p>
    <br/>
</p>
<p style="text-indent: 34.67px; ">
    八、联系方式
</p>
<p style="text-indent: 34.67px; ">
    如您在阅读本协议过程中有任何疑惑或其他相关事宜的（包括问题咨询、投诉等），您可以通过以下方式与我们取得联系：
</p>
<p style="text-indent: 34.67px; ">
    （1）根据操作指引登录平台，进行在线投诉和反馈；
</p>
<p style="text-indent: 34.67px; ">
    （2）拨打人工客服电话0571-86066079与我们取得联系；
</p>
<p style="text-indent: 34.67px; ">
    （3）发邮件至service@zhiaotech.com进行询问；
</p>
<p style="text-indent: 34.67px; ">
    （4）点击微信公众号“小奥编程”中的“联系客服”功能；
</p>
<p style="text-indent: 34.67px; ">
    以及（5）我们提供的其他联系方式。我们会在收到您的意见及建议后尽快为您答复。
</p>
</article>`



const privacy = `
<article>
<p>
    <span style="font-size:12pt;">版本更新日期：【2022】年【04】月【29】日
</p>
<p>
    <span style="font-size:12pt;">版本生效日期：【2022】年【04】月【29】日
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程尊重并保护用户隐私，在您使用小奥AI编程提供的服务时，我们将按照《小奥AI编程用户隐私保护政策》（以下简称</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">“</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">本隐私政策</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">”</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">）收集、使用及共享您的个人信息。本隐私政策包含了我们收集、存储、使用、共享和保护您的个人信息的条款，我们希望通过本隐私政策向您清晰地介绍我们对您个人信息的处理方式，因此我们建议您完整地阅读本隐私政策，以帮助您了解维护自己隐私权的方式。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">如果您不同意本隐私政策任何内容，您应立即停止使用小奥AI编程产品或服务。当您使用小奥AI编程提供的任一服务时，即表示您已同意我们按照本隐私政策来合法使用和保护您的个人信息。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">一、&nbsp;适用范围</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">本隐私政策适用于小奥AI编程提供的所有服务，您访问小奥AI编程网站、客户端均适用本隐私政策。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">二、&nbsp;我们收集哪些信息</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">为了向您提供更好、更优、更个性化的服务，我们将根据您使用的服务收集您的如下信息：</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(1)您向我们提供的信息。您在登录注册时，向我们提供的相关个人信息，例如电话号码、姓名等；我们还会记录您在使用我们服务时提供的信息，例如您参与问卷调查时向我们发送的问卷答复信息等。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(2)在您使用服务过程中产生的信息。我们会根据您授予的权限，接收并记录您所使用的设备相关信息，这些设备信息包括：设备属性信息（如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备位置信息（如通过GPS、蓝牙或WIFI信号获得的位置信息）、设备连接信息（IP地址、电信运营商、使用的语言、访问日期和时间等）。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">来自第三方的信息。当您与使用我们服务的关联公司、小奥AI编程合作伙伴之间互动时，为共同向您提供服务及改进服务质量的合理需要，我们将从关联公司、合作伙伴处接收关于您的体验或您与其互动的信息。</span>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">三、&nbsp;我们如何收集信息</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">我们或我们的第三方合作伙伴，可能通过cookies和web&nbsp;beacon收集和使用您的信息，并将该等信息储存为日志信息。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">我们使用自己的cookies和web&nbsp;beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(1)记住您的身份。例如：cookies和web&nbsp;beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(2)分析您使用我们服务的情况。例如，我们可利用cookies和web&nbsp;beacon来了解您使用我们的服务进行什么活动，或哪些服务最受您的欢迎。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">您可以通过终端设备设置拒绝或管理cookies或web&nbsp;beacon。但请注意，如果停用cookies或web&nbsp;beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">四、&nbsp;我们如何使用收集到的信息</span>
</p>
<p>
    <br/>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">收集您的信息是为了向您提供服务及提升服务质量，我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用服务过程中主动提供或因使用服务而产生的个人信息，以及从第三方获取您的相关个人信息。</span><span style="font-weight:bold;font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">我们会把您的信息用于下列用途：</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(1)向您提供您使用的各项服务，并维护、改进这些服务。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(2)向您推荐您可能感兴趣的内容，包括但不限于向您发出产品和服务信息。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(3)我们可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、我们的其他用户、我们或我们关联方的合法权益。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(4)当您注册我们账号时，您至少需要向我们提供您准备使用的账号名、密码、手机号码、电子邮箱，我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效，通过SIM卡信息识别并显示对应的运营商。您的账号名为您的默认昵称，您可以修改和补充您的昵称、性别、生日以及您的实名认证相关信息，这些信息均属于您的</span><span style="font-size:12pt;font-family:宋体, 宋体, 宋体, 宋体">“账号信息”</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">。您补充的账号信息将有助于我们为您提供个性化的商品推荐和更优的购物体验，但如果您不提供这些补充信息，不会影响您使用网上购物的基本功能。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">6</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">)为了向您展示商品或者服务，我们会收集您的设备信息（包括设备名称、设备型号、MAC地址及IMEI、设备识别码、移动应用列表等软硬件特征信息、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、设备所在位置相关信息（包括您授权的GPS位置信息以及WLAN接入点、蓝牙和基站传感器信息）、浏览器类型来对相应的商品或者服务内容进行排序以适应您的设备界面。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">7</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">)当您准备结算商品时，平台会生成您购买商品的订单。若您需要开具发票，</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">请</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">提供发票抬头、纳税人识别号以及接收发票的电子邮箱。</span>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">上述所有信息构成您的</span><span style="font-size:12pt;font-family:宋体, 宋体, 宋体, 宋体">“订单信息”</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">8</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">)</span><span style="font-size:11pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">在您下单后，您可以选择与平台合作的第三方支付机构（包括支付宝支付、微信支付及银联、网联等支付通道，以下称</span><span style="font-size:11pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">“</span><span style="font-size:11pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">支付机构</span><span style="font-size:11pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">”</span><span style="font-size:11pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的订单号与交易金额信息，包括您的银行卡号、有效期及其他银行卡（含储蓄卡、信用卡）支付必要信息与这些支付机构共享以实现其确认您的支付指令并完成支付。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">9</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">)我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">(</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">10</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">)经您许可的其他用途。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">但无论如何，我们仅在本隐私政策所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">五、链接</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程的网页和软件上可能会放置第三方链接，小奥AI编程对其他任何第三方的内容、隐私政策或运营，或经营这些第三方网站或者软件的公司的行为概不负责。在向这些网站提供个人信息之前，请查阅它们的隐私政策。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">六、不可抗力及其他免责事由</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，小奥AI编程将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，小奥AI编程及合作单位在法律允许的范围内免责。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">“</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">特洛伊木马</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">“</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，小奥AI编程不承担任何责任。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">用户理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，小奥AI编程不承担任何责任。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">用户理解并确认，小奥AI编程需要定期或不定期地对</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">“</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">“</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，小奥AI编程无需为此承担任何责任，但小奥AI编程应事先进行通告。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成小奥AI编程的义务或承诺，小奥AI编程不能保证及时发现违法违规或违约行为或进行相应处理。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">用户理解并确认，对于小奥AI编程向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失，小奥AI编程无需承担任何责任：</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程向用户免费提供的服务；</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程向用户赠送的任何产品或者服务。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">在任何情况下，小奥AI编程均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">“</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">“</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">或本服务而遭受的利润损失，承担责任（即使小奥AI编程已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，小奥AI编程对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用小奥AI编程提供的服务而支付给小奥AI编程的费用(如有)。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">七、服务的变更、中断、终止</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">鉴于网络服务的特殊性，用户同意小奥AI编程有权随时变更、中断或终止部分或全部的服务（包括收费服务）。小奥AI编程变更、中断或终止的服务，小奥AI编程应当在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务；如用户不愿意接受替代性的服务，如果该用户已经向小奥AI编程的虚拟账户充值，小奥AI编程应当按照该用户实际使用服务的情况扣除相应款项之后将剩余的款项退还用户的虚拟账户中。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">如发生下列任何一种情形，小奥AI编程有权变更、中断或终止向用户提供的免费服务或收费服务，而无需对用户或任何第三方承担任何责任：</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">用户违反相关法律法规或本协议的约定；</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">按照法律规定或有权机关的要求；</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">出于安全的原因或其他必要的情形。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">八、其他</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">小奥AI编程郑重提醒用户注意本协议中免除小奥AI编程责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议,&nbsp;并在其法定监护人的同意下使用本服务。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和小奥AI编程之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman">杭州致奥数据科技有限公司</span><span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">住所地有管辖权的人民法院管辖。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">本政策的修订</span>
</p>
<p>
    <br/>
</p>
<p>
    <span style="font-size:12pt;font-family:Times New Roman, Times New Roman, Times New Roman, 宋体">我们可不定期修改本隐私政策，变更后的隐私政策将在修订生效前通过小奥AI编程平台公告或以其他适当方式通知您。该等情况下，若您继续使用我们的服务，即表示同意受经修订的隐私政策的约束。</span>
</p>
<p>
    <br/>
</p>
</article>`

const vipmember =  `<p>
<span style="font-size:14px"><span >版本更新日期：【</span>2022<span >】年【</span>04<span >】月【</span>29<span >】日</span></span>
</p>
<p>
<span style="font-size:14px"><span >版本生效日期：【</span>2022<span >】年【</span>04<span >】月【</span>29<span >】日</span></span>
</p>
<p>
<span style="font-size:14px">&nbsp;</span>
</p>
<p>
<span style="font-size:14px"><span >欢迎您开通小奥</span><span >AI编程</span></span><span style="font-size:14px">VIP</span><span style="font-size:14px"><span >会员。小奥</span><span >AI编程</span></span><span style="font-size:14px">VIP</span><span style="font-size:14px"><span >会员由小奥</span><span >AI编程网站所有者开发，旨在为用户（以下更多的称为「您」）提供付费的增值会员权益。</span></span>
</p>
<p>
<strong><span style="font-size: 14px">请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或限制责任的相应条款</span></strong><strong><span style="font-size: 14px">、</span></strong><strong><span style="font-size: 14px">法律适用和争议解决条款</span></strong><strong><span style="font-size: 14px">。</span></strong><strong><span style="font-size: 14px">免除或者限制责任的条款将以粗体标识，您应重点阅读。</span></strong><span style="font-size:14px">未成年人应在法定监护人的陪同下阅读并决定是否同意本协议。</span>
</p>
<p style="text-indent:28px">
<span style="font-size:14px">当您按照</span><span style="font-size:14px"><span >小奥</span><span >AI编程</span></span><span style="font-size:14px">VIP</span><span style="font-size:14px">会员</span><span style="font-size:14px">开通页面提示阅读并同意本协议且完成全部开通程序后，即表示</span><span style="font-size:14px">您已阅读</span><span style="font-size:14px">、</span><span style="font-size:14px">理解</span><span style="font-size:14px">并同意接受本协议的</span><span style="font-size:14px">全部内容</span><span style="font-size:14px">。</span><strong><span style="font-size: 14px">阅读本协议过程中，</span></strong><strong><span style="font-size: 14px">如果您对本协议的任何条款表示异议，您可以选择不开通本产品。</span></strong>
</p>
<p>
<span style="font-size:14px">一、&nbsp;</span><span style="font-size:14px">服务内容</span>
</p>
<p>
<span style="font-size:14px">1.&nbsp;</span><span style="font-size:14px">VIP</span><span style="font-size:14px"><span >会员是小奥</span><span >AI编程为用户打造的增值产品，包含多种专有的会员权益。</span></span>
</p>
<p>
<span style="font-size:14px">2.&nbsp;</span><span style="font-size:14px">VIP</span><span style="font-size:14px"><span >会员所包含的会员权益以服务页面信息为准。小奥</span><span >AI编程有权根据业务发展情况调整全部或者部分会员权益。前述调整将在会员服务页面进行公告，您也可以随时向客服了解当下会员权益的具体情况。</span></span>
</p>
<p>
<span style="font-size:14px">二、&nbsp;</span><span style="font-size:14px">开通和终止</span>
</p>
<p>
<span style="font-size:14px">1.&nbsp;</span><span style="font-size:14px"><span >您同意本协议并支付会员费用或者使用其他方式成为会员，即可获得小奥</span><span >AI编程</span></span><span style="font-size:14px">VIP</span><span style="font-size:14px">会员资格（以下简称「会员资格」）。</span>
</p>
<p>
<span style="font-size:14px">2.&nbsp;</span><span style="font-size:14px">VIP</span><span style="font-size:14px">会员有效期：</span><strong><span style="font-size: 14px">自会员资格开通之日起算，</span></strong><strong><span style="font-size: 14px">365</span></strong><strong><span style="font-size: 14px">个自然日。</span></strong><span style="font-size:14px"><span >会员在会员有效期内续费或通过其他方式续展会员期限，有效期将相应延长。会员在会员资格到期后未以任何方式续展期限，小奥</span><span >AI编程有权停止提供相应会员权益。</span></span>
</p>
<p>
<span style="font-size:14px">3.&nbsp;</span><span style="font-size:14px">您在开通</span><span style="font-size:14px">VIP</span><span style="font-size:14px">会员时，应仔细核对账号信息、会员期限、会员费用等信息。</span><strong><span style="font-size: 14px">由于</span></strong><strong><span style="font-size: 14px">VIP</span></strong><strong><span style="font-size: 14px"><span >会员是数字化商品，基于互联网服务的特殊性和国家相关管理规定，如因您的个人原因发生错误购买或无法正常享受会员权益，小奥</span><span >AI编程不能退还相应会员费。</span></span></strong>
</p>
<p>
<span style="font-size:14px">4.&nbsp;</span><span style="font-size:14px">会员未使用</span><span style="font-size:14px">VIP</span><span style="font-size:14px">会员权益的，不视为放弃相应权利。</span><strong><span style="font-size: 14px"><span >但会员如果违反小奥</span><span >AI编程服务协议相关规定，或会员账号有异常情况，小奥AI编程有权根据管理规定对相应会员账号采取限制或冻结措施。此种情况下，会员的账号功能及会员权益将受到限制。</span></span></strong>
</p>
<p>
<span style="font-size:14px">三、&nbsp;</span><span style="font-size:14px">会员费用及续费</span>
</p>
<p>
<span style="font-size:14px">1.&nbsp;</span><span style="font-size:14px"><span >小奥</span><span >AI编程</span></span><span style="font-size:14px">VIP</span><span style="font-size:14px"><span >会员费以您购买会员时，服务页面标示的价格为准。小奥</span><span >AI编程不时推出优惠活动，会在服务页面公示。</span></span>
</p>
<p>
<span style="font-size:14px">2.&nbsp;</span><span style="font-size:14px"><span >小奥</span><span >AI编程暂不提供自动续费功能。</span></span>
</p>
<p>
<span style="font-weight:bold;font-size:14px">3.&nbsp;</span><strong><span style="font-size: 14px"><span >小奥</span><span >AI编程VIP会员服务系网络商品和虚拟商品</span></span></strong><strong><span style="font-size: 14px">，</span></strong><strong><span style="font-size: 14px">不在法定七日内无理由退货的范围内</span></strong><strong><span style="font-size: 14px">，</span></strong><strong><span style="font-size: 14px">故请您谨慎支付</span></strong><strong><span style="font-size: 14px">。</span></strong><strong><span style="font-size: 14px">一旦支付成功</span></strong><strong><span style="font-size: 14px">，</span></strong><strong><span style="font-size: 14px">除非法律规定</span></strong><strong><span style="font-size: 14px">、</span></strong><strong><span style="font-size: 14px">本协议或特定协议或特定产品具体规则另有约定</span></strong><strong><span style="font-size: 14px">，</span></strong><strong><span style="font-size: 14px"><span >您所购买的</span><span >VIP会员服务不支持退款操作</span></span></strong><strong><span style="font-size: 14px">。</span></strong>
</p>
<p>
<span style="font-size:14px">四、&nbsp;</span><span style="font-size:14px">会员账号管理</span>
</p>
<p>
<span style="font-size:14px">1.&nbsp;</span><span style="font-size:14px"><span >会员应合理使用会员权益、享受会员服务。小奥</span><span >AI编程将通过页面公告或私信等方式向会员发布通知。会员应及时关注相关信息的更新。</span></span>
</p>
<p>
<span style="font-size:14px">2.&nbsp;</span><span style="font-size:14px"><span >会员应遵守小奥</span><span >AI编程的各项规则，包括但不限于本协议，以及《用户服务协议》、《用户隐私保护政策》等相关规范，以及小奥AI编程不时发布的与用户相关的各项通知、公告（本协议内统称「管理规定」）。</span></span>
</p>
<p>
<span style="font-weight:bold;font-size:14px">3.&nbsp;</span><strong><span style="font-size: 14px"><span >小奥</span><span >AI编程会员服务及会员权益仅限您本人使用，</span></span></strong><span style="font-size:14px">具体使用可能需要您开通会员的会员账户进行。</span><strong><span style="font-size: 14px">开通会员服务或获取会员权益的账户（包括</span></strong><strong><span style="font-size: 14px"><span >小奥</span><span >AI编程</span></span></strong><strong><span style="font-size: 14px">会员账户、第三方账户）作为您享受相应服务及权益的重要身份标识，用户名、密码和生物特征（如有）均由您自行设置并保管。</span></strong>
</p>
<p>
<span style="font-size:14px">4.&nbsp;</span><span style="font-size:14px">会员账户或第三方账户与您的会员权益及资格密切挂钩，交由他人使用可能会造成您本人在权益使用上产生不良影响，因此</span><span style="font-size:14px"><span >小奥</span><span >AI编程</span></span><span style="font-size:14px">请您不要将自己的账户给予他人使用；</span><strong><span style="font-size: 14px">从公平合理的角度，您应知晓所有通过该账户实现的操作</span></strong><strong><span style="font-size: 14px"><span >小奥</span><span >AI编程</span></span></strong><strong><span style="font-size: 14px">只能默认视为您本人的行为，由此产生的后果由您与实际使用者自行承担。</span></strong>
</p>
<p>
<span style="font-weight:bold;font-size:14px">5.&nbsp;</span><strong><span style="font-size: 14px"><span >因不能归责于小奥</span><span >AI编程的原因导致的会员账号密码泄露或会员权益受损，小奥AI编程不承担任何责任。</span></span></strong><span style="font-size:14px"><span >会员发现账号被盗，应及时修改密码或通过管理规定找回账号。为避免账号盗用引起的风险，小奥</span><span >AI编程有权主动限制、冻结异常账号，暂停或终止为异常账号提供会员权益。</span></span>
</p>
<p>
<span style="font-size:14px">6.&nbsp;</span><span style="font-size:14px"><span >如果会员因违反小奥</span><span >AI编程管理规定而被限制账号权限，其会员资格依旧有效，但所享受的相关会员权益将受到一定限制。</span></span>
</p>
<p>
<span style="font-size:14px">7.&nbsp;</span><span style="font-size:14px">会员不得以不正当手段获取会员资格，不得将会员账号以出借、出租、出售等任何形式提供给第三方使用，不得以任何形式向第三方分享或售卖其所享有的会员权益，不得滥用会员权益，不得利用会员资格获取不正当利益。</span><strong><span style="font-size: 14px"><span >如小奥</span><span >AI编程</span></span></strong><strong><span style="font-size: 14px">有合理理由怀疑</span></strong><strong><span style="font-size: 14px">会员存在不当</span></strong><strong><span style="font-size: 14px">行为</span></strong><strong><span style="font-size: 14px"><span >，违反管理规定，或以任何形式损害小奥</span><span >AI编程或其他用户权益的，小奥AI编程有权暂停或取消该会员的会员资格，且不退还已收取的会员费。此外，违规会员需承担因此引起的一切责任和后果。</span></span></strong>
</p>
<p>
<span style="font-size:14px">8.&nbsp;</span><span style="font-size:14px"><span >您在获取小奥</span><span >AI编程会员服务时，应当遵守法律法规、本协议约定，不侵犯第三方或小奥AI编程的合法权益。您不得自行（或协助他人）通过以下方式获取会员服务：</span></span>
</p>
<p style="margin-left:0;text-indent:0">
<span style="font-size:14px"><span >（</span><span >1）以商业性或其他非个人使用等目的；</span></span>
</p>
<p style="margin-left:0;text-indent:0">
<span style="font-size:14px"><span >（</span><span >2）通过机器人软件、蜘蛛软件、爬虫软件等任何自动程序、脚本、软件等方式：</span></span>
</p>
<p style="margin-left:0;text-indent:0">
<span style="font-size:14px"><span >（</span><span >3）未经小奥AI编程允许通过借用、租用、售卖、分享、转让会员服务的方式；</span></span>
</p>
<p style="margin-left:0;text-indent:0">
<span style="font-size:14px"><span >（</span><span >4）通过不正当手段或以违反信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等）</span></span>
</p>
<p style="margin-left:0;text-indent:0">
<span style="font-size:14px"><span >（</span><span >5）通过利用或破坏小奥AI编程会员服务规则的方式。</span></span>
</p>
<p>
<span style="font-size:14px">9.&nbsp;</span><span style="font-size:14px">同一会</span><span style="font-size:14px">员账号最多可以在五个设备（「设备」指包括但不限于计算机及移动电话、平板电脑等的终端设备）上使用，且同一时间内同一账号最多在两个设备上使用。超过上</span><span style="font-size:14px"><span >述范围使用的，小奥</span><span >AI编程有权暂停或终止提供会员权益并取消该会员的会员资格。此外，违反会员需承担因此引起的一切责任和后果。</span></span>
</p>
<p>
<span style="font-weight:bold;font-size:14px">10.&nbsp;</span><strong><span style="font-size: 14px"><span >因可归因于会员自身的原因引起的纠纷与小奥</span><span >AI编程无关，会员应当自行承担相应责任。如果该等纠纷损害小奥AI编程的合法权益，小奥AI编程有权取消会员的会员资格，且不退还已收取的会员费。</span></span></strong><span style="font-size:14px"><span >同时，小奥</span><span >AI编程有权以合法手段维护自身权益。</span></span>
</p>
<p>
<span style="font-size:14px">五、&nbsp;</span><span style="font-size:14px">您的个人信息保护</span>
</p>
<p style="margin-left:32px">
<span style="font-size:14px">1、</span><span style="font-size:14px"><span >小奥</span><span >AI编程深知个人信息对您的重要性，因此小奥AI编程非常重视保护您的个人信息，亦将您的个人信息以高度审慎的义务对待和处理。在您使用会员服务的过程中，小奥AI编程将采用相关技术措施及其他安全措施来保护您的个人信息。</span></span>
</p>
<p style="margin-left:32px">
<span style="font-size:14px">2、</span><span style="font-size:14px">未成年人保护</span>
</p>
<p style="margin-left:32px;text-indent:0">
<span style="font-size:14px"><span >小奥</span><span >AI编程非常注重未成年人的保护。若您为未成年人，应在监护人监护、指导下阅读本协议，并且使用会员服务已经得到监护人的同意。</span></span>
</p>
<p style="margin-left:32px">
<span style="font-size:14px">3、</span><span style="font-size:14px"><span >更多关于个人信息处理和保护规则、用户对个人信息的控制权等内容，请您至小奥</span><span >AI编程上查阅《</span></span><span style="font-size:14px">用户</span><span style="font-size:14px">隐私</span><span style="font-size:14px">保护</span><span style="font-size:14px">政策》的全文。</span>
</p>
<p>
<span style="letter-spacing: 0;font-size: 14px">六、&nbsp;</span><span style="letter-spacing: 0;font-size: 14px">服务的中断和终止</span>
</p>
<p style="text-indent: 0">
<span style="font-size:14px">1、本服务的中断或终止包括如下情况：</span>
</p>
<p style="text-indent: 32px">
<span style="font-size:14px"><span >（</span><span >1）您主动提出要求的；</span></span>
</p>
<p style="text-indent: 32px">
<span style="font-size:14px"><span >（</span><span >2）您存在任何违反国家法律法规或监管政策、违反本协议或有损小奥AI编程的声誉、利益的行为的；</span></span>
</p>
<p style="text-indent: 32px">
<span style="font-size:14px"><span >（</span><span >3）小奥AI编程根据法律法规、监管政策的规定或有权机关的要求；</span></span>
</p>
<p style="text-indent: 32px">
<span style="font-size:14px"><span >（</span><span >4）小奥AI编程为维护账号与系统安全等紧急情况之需要；</span></span>
</p>
<p style="text-indent: 32px">
<span style="font-size:14px"><span >（</span><span >5）不可抗力（不可抗力是指：不能预见、不能避免且不能客服的客观情况，包括国家法律、法规、政策及国家机关 的命令及其他政府行为或者其它的诸如台风、洪水、地震、海啸、战争、罢工等）；</span></span>
</p>
<p style="text-indent: 32px">
<span style="font-size:14px"><span >（</span><span >6）其他小奥AI编程无法抗拒的情况。</span></span>
</p>
<p style="margin-left: 32px">
<strong><span style="font-size: 14px">2、当发生前述终止的情况时，小奥AI编程将根据法律法规的规定与您就本服务的中断或终止事宜逬行处理。</span></strong>
</p>
<p>
<span style="font-size:14px">七、&nbsp;</span><span style="font-size:14px">协议修改</span>
</p>
<p>
<span style="font-size:14px">1.&nbsp;</span><span style="font-size:14px"><span >根据互联网的发展和有关法律、法规及规范文件的变化，或者因小奥</span><span >AI编程业务发展需要，小奥AI编程有权对本协议的条款作出修改和变更，一旦本协议的内容发生变动，小奥AI编程将根据实际情况选择以包括但不限于系统提示、公告、站内信等方式提示您。</span></span>
</p>
<p>
<span style="font-size: 14px">2.&nbsp;</span><span style="font-size: 14px"><span >如果您不同意小奥</span><span >AI编程对本协议相关条款所做的修改，您有权停止使用小奥AI编程会员。如果您继续使用，则视为您接受小奥AI编程对本协议相关条款所做的修改。</span></span>
</p>
<p>
<span style="font-size:14px">八、&nbsp;</span><span style="font-size:14px">适用法律及争议解决</span>
</p>
<p>
<span style="font-weight:bold;font-size:14px">1.&nbsp;</span><strong><span style="font-size: 14px">本协议的成立、生效、履行、解释及争议的解决均适用中华人民共和国大陆地区法律。如本协议的任何约定与中华人民共和国大陆地区的法律抵触而无效，则这些条款将按照尽可能接近本协议原文的目的进行重新解释，本协议其他约定仍应具有完整的效力及效果。</span></strong>
</p>
<p>
<span style="font-weight:bold;font-size:14px">2.&nbsp;</span><strong><span style="font-size: 14px"><span >若您与小奥</span><span >AI编程发生争议的，双方应尽量友好协商解决。协商不成，双方均同意将争议提交至小奥AI编程所在地有管辖权的人民法院。</span></span></strong>
</p>
<p>
<span style="font-size:14px">九、&nbsp;</span><span style="font-size:14px">其他</span>
</p>
<p>
<span style="font-size:14px">1.&nbsp;</span><span style="font-size:14px"><span >如因不可抗力或其他小奥</span><span >AI编程无法控制的原因，导致小奥AI编程不能正常提供会员权益的，小奥AI编程将发布通知并合理处理善后事宜，尽量降低会员损失。</span></span>
</p>
<p>
<span style="font-size:14px">2.&nbsp;</span><span style="font-size:14px">如果您对本协议内容有任何疑问，请私信联系客服。</span>
</p>`

export {
  service,
  privacy,
  vipmember
}
